module.exports = __webpack_public_path__ + "static/media/404-banner1.c0cca7a7.png";